<div class="notifications__header">
  <button
    class="notifications__mark-all"
    type="button"
    [disabled]="tasks.length === 0"
    (click)="onClearAll()"
  >
    Limpar tudo
  </button>
</div>

<div class="notifications__list" *ngIf="tasks.length > 0">
  <div
    class="notifications__item"
    *ngFor="let task of tasks; trackBy: trackByTask"
    [class.notifications__item--unread]="!task.read"
    (click)="$event.stopPropagation()"
  >
    <div
      class="notifications__icon notifications__icon--{{
        task.isExecuting ? 'info' : (task.successful ? 'success' : 'error')
      }}"
    >
      <i class="fas fa-spinner fa-pulse" *ngIf="task.isExecuting"></i>
      <i class="fas fa-check" *ngIf="!task.isExecuting && task.successful"></i>
      <i class="fas fa-times" *ngIf="!task.isExecuting && !task.successful"></i>
    </div>
    <div class="notifications__item-content">
      <span class="notifications__item-title">{{ task.name }}</span>
      <span class="notifications__item-message">{{ task.description }}</span>
      <a
        class="notifications__task-error-link"
        *ngIf="!task.isExecuting && !task.successful"
        (click)="onShowError(task)"
      >Ver erro</a>
    </div>
    <span class="notifications__task-time" *ngIf="task.finishedAt">{{ task.finishedAt | date: 'HH:mm' }}</span>
    <span class="notifications__unread-dot" *ngIf="!task.read"></span>
  </div>
</div>

<div class="notifications__empty" *ngIf="tasks.length === 0">
  <i class="fas fa-tasks"></i>
  <span>Nenhuma tarefa</span>
</div>
